import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import Header from '../../components/ui/Header';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import SettingsTab from './components/SettingsTab';
import GeneralSettings from './components/GeneralSettings';
import UserManagement from './components/UserManagement';
import IntegrationSettings from './components/IntegrationSettings';
import SecuritySettings from './components/SecuritySettings';
import BackupSettings from './components/BackupSettings';
import GDPRSettings from './components/GDPRSettings';
import CustomScriptsSettings from './components/CustomScriptsSettings';
import DeploymentSettings from './components/DeploymentSettings';

const SettingsCentral = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('general');

  const tabs = [
    { id: 'general', label: 'General', icon: 'Settings' },
    { id: 'users', label: 'Users', icon: 'Users', badge: '5' },
    { id: 'integrations', label: 'Integrations', icon: 'Plug' },
    { id: 'security', label: 'Security', icon: 'Shield' },
    { id: 'backup', label: 'Backup', icon: 'Database' },
    { id: 'gdpr', label: 'GDPR & Privacy', icon: 'ShieldCheck' },
    { id: 'scripts', label: 'Custom Scripts', icon: 'Code' },
    { id: 'deployment', label: 'Deployment', icon: 'Server' },
  ];

  const breadcrumbItems = [
    { label: 'Dashboard', path: '/dashboard-home', icon: 'Home' },
    { label: 'Settings Central', path: '/settings-central', icon: 'Settings' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return <GeneralSettings />;
      case 'users':
        return <UserManagement />;
      case 'integrations':
        return <IntegrationSettings />;
      case 'security':
        return <SecuritySettings />;
      case 'backup':
        return <BackupSettings />;
      case 'gdpr':
        return <GDPRSettings />;
      case 'scripts':
        return <CustomScriptsSettings />;
      case 'deployment':
        return <DeploymentSettings />;
      default:
        return <GeneralSettings />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Sidebar
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={setSidebarCollapsed}
      />

      <Header
        isCollapsed={sidebarCollapsed}
        userName="Sarah Mitchell"
        userRole="Content Manager"
      />

      <main
        className={`main-content with-sidebar ${
          sidebarCollapsed ? 'collapsed' : ''
        }`}
      >
        <div className="p-4 md:p-6 lg:p-8 space-y-4 md:space-y-6">
          <div className="flex flex-col gap-3 md:gap-4">
            <Breadcrumbs items={breadcrumbItems} />
            
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
                Settings Central
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Manage your site configuration, users, integrations, and security settings
              </p>
            </div>
          </div>

          <div className="bg-card rounded-lg border border-border overflow-hidden">
            <SettingsTab
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />

            <div className="p-4 md:p-6 lg:p-8">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SettingsCentral;